import './index.css'


// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-checkbox/style/index.js